import axios from "axios";
import type { SignatureFileParams } from "../types";

const plainAxios = axios.create();

export async function signatureUploadFile(
	payload: SignatureFileParams
): Promise<void> {
	const { url, file, contentType } = payload;

	await plainAxios.put(url, file, {
		headers: { "Content-Type": contentType },
	});
}
